<template>
  <div class="about">
    <V-header />
    <V-sidebar />
    <div class="content-box" :class="{ 'content-collapse': collapse }">
      <!-- <v-tags></v-tags> -->
      <div class="content" ref="content" id="content">
        <router-view v-slot="{ Component }">
          <transition name="move" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>
        <!-- <el-backtop target=".content"></el-backtop> -->
      </div>
    </div>
  </div>
</template>
<script>
import VHeader from "../components/Header";
import VSidebar from "../components/Sidebar";
// import vTags from "../components/Tags.vue";
export default {
  components: {
    VHeader,
    VSidebar,
    // vTags,
  },
  data() {
    return {};
  },
  mounted() {
    localStorage.setItem("ContentHeight", this.$refs.content.clientHeight);
  },
  computed: {
    tagsList() {
      return this.$store.state.tagsList.map((item) => item.name);
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
};
</script>
<style lang="scss">
.content-box {
  position: absolute;
  left: 180px;
  right: 0;
  top: 60px;
  bottom: 0;
  //   padding-bottom: 30px;
  -webkit-transition: left 0.3s ease-in-out;
  transition: left 0.3s ease-in-out;
  background: #ffffff;
}

.content {
  width: auto;
  height: 100%;
  padding: 10px;
  overflow-y: auto;
  box-sizing: border-box;
}

.content-collapse {
  left: 65px;
}
</style>
